/**
 * Created by rafael on 07.03.17.
 */
import {
  INCREMENT,
  SEARCHBOX_STATUS,
  TOGGLE_SEARCHBOX_STATUS,
} from '../constants';

const initialState = {
  bounceCounter: 0,
  searchboxStatus: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INCREMENT:
      return {
        ...state,
        bounceCounter: state.bounceCounter + action.value,
      };
    case SEARCHBOX_STATUS:
      return {
        ...state,
        searchboxStatus: action.visibility,
      };
    case TOGGLE_SEARCHBOX_STATUS:
      return {
        ...state,
        searchboxStatus: !state.searchboxStatus,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/reducers/style.js